export default "assets/images/icons/user-9a57a512.svg";